import React from 'react'
import {Button, useNavigate} from '@startlibs/components'
import {Errors, TextInput, validation, WithForm} from '@startlibs/form'
import {getColor, getFetcher, postFetcher} from '@startlibs/utils'
import {useToggle} from '@startlibs/core'
import {bearerHeader} from '../reducers'
import {required} from '../lib/validation'
import styled from 'styled-components'
import {Card, CardHeader, SignInLayout} from '../components/SigninLayout'
import {FormattedMessage, useIntl} from "react-intl";

// max-width: 35rem;
const SignInCard = styled(Card)`
  max-width: 40rem;
  margin: auto;
`

const ResendCodeMessage = styled.div`
  color: rgba(0,0,0,0.5);
  margin-top: 1rem;
  p {
    margin-bottom: 0.25rem;
  }
  .link {
    font-weight: 600;
  }
  .detail {
    font-size: 12px;
  }
  .loading {
    color: ${getColor('main')};
    font-weight: 600;
  }
  .success {
    color: ${getColor('success')};
  }
`

const ButtonsContainer = styled.div`
  margin-top: 2rem;
  text-align: center;
`

export const TwoFactorAuthentication = ({userToggle, system, concludeLogin, preAuthToken, username, passwordExpired}) => {
  const intl = useIntl()
  const loading = useToggle()
  const resendingCode = useToggle()
  const resentCode = useToggle()
  const navigate = useNavigate()

  const onFailure = validation.responseFailure((response) => {
    console.log(response)
    if (response.status === 403) {
      passwordExpired(response.params.key)
    } else if (response.status === 401) {
      logout(true)
    } else {
      const {detail, message, status} = response
      return ((status === 400) && {'oneTimePassword': [intl.formatMessage({
        defaultMessage: `Invalid or expired code.`,
        description: `2FA error message`
      })]})
    }
  })

  const logout = (expired) => {
    userToggle.openWith({})
    navigate(`/?systemId=${system.systemId}&username=${username}`,{state:{loginKey:Date.now(),expiredSession:expired}})
  }

  const onSuccess = (_, {id_token}) => {
    loading.open()
    concludeLogin(id_token)
  }

  const resend = () => {
    resentCode.close()
    resendingCode.open()
    getFetcher(`/pasapi/generate-2fa-code?locale=${intl.locale}`, undefined, bearerHeader(preAuthToken))
      .then(() => {
        resentCode.open()
        resentCode.closeAfter(30000)
        resendingCode.close()
      })
  }


  const preValidation = validation.buildValidation({
    oneTimePassword: [required(intl)]
  })
  return (
    <SignInLayout system={system}>
      <SignInCard>
        <CardHeader>
          <h1><FormattedMessage
            defaultMessage="Two-Factor Authentication"
            description="2FA title"
          /></h1>
          <p><FormattedMessage
            defaultMessage="A temporary code was just sent to your e-mail."
            description="2FA instructions"
          /></p>
        </CardHeader>
        <WithForm
          alwaysSave
          preValidation={preValidation}
          onSuccess={onSuccess}
          onFailure={onFailure}
          id_token={preAuthToken}
          action={({oneTimePassword}) =>
            postFetcher('/pasapi/verify-2fa-code', oneTimePassword,bearerHeader(preAuthToken))
          }
        >{form => <>
          <TextInput
            tabIndex={1}
            label={intl.formatMessage({
              defaultMessage: "Code",
              description: "2FA code label"
            })}
            constraint="###############"
            placeholder={intl.formatMessage({
              defaultMessage: "Enter the code here",
              description: "2FA code placeholder"
            })}
            form={form}
            path="oneTimePassword"
            name="oneTimePassword"
          />
          <Errors />
          <ResendCodeMessage>
            {resentCode.isOpen ?
              <p className="success"><FormattedMessage
                defaultMessage="New email successfully sent."
                description="2FA success message"
              /></p>
              :
              <p><FormattedMessage
                defaultMessage="Did not get the email?"
                description="2FA resend message"
              />{resendingCode.isOpen
                ? <b className="loading"><FormattedMessage
                  defaultMessage="Sending..."
                  description="2FA sending message"
                /></b>
                : <span> <a className="link" onClick={resend}><FormattedMessage
                  defaultMessage="Resend it"
                  description="2FA resend link"
                /></a>.</span>}</p>
            }
            <p className="detail"><FormattedMessage
              defaultMessage="Please also check your spam or junk folder if necessary."
              description="2FA spam message"
            /></p>
          </ResendCodeMessage>
          <ButtonsContainer>
            <Button tabIndex={2} onClick={() => logout()} type="button"><FormattedMessage
              defaultMessage="Cancel"
              description="2FA cancel button"
            /></Button>
            <Button highlight isLoading={form.isLoading || loading.isOpen} tabIndex={1} type="submit"><FormattedMessage
              defaultMessage="Next"
              description="2FA submit button"
            /></Button>
          </ButtonsContainer>
        </>}</WithForm>
      </SignInCard>
    </SignInLayout>
  )
}